<template>
    <div class="modal-body">
        <form class="mb-4">
            <div class="input-group input-group-merge">
                <input type="search" v-model="search" class="form-control form-control-prepended" placeholder="Tìm theo tỉnh, thành phố">
                <div class="input-group-prepend">
                    <div class="input-group-text">
                        <span class="fe fe-search"></span>
                    </div>
                </div>
            </div>
        </form>

        <div class="my-n3">
            <div class="list-group list-group-flush" v-if="regions.length > 0">
                <a 
                    v-for="region in filteredRegions" 
                    :key="region.id"
                    :href="url('orn_web_cinema_region', { slug: region.slug })" 
                    class="list-group-item d-flex justify-content-between align-items-center px-0" 
                    @click.prevent="doChangeRegion(region)"
                >
                    <h4 class="text-body mb-0">
                        {{ region.name }}
                        <span class="small text-muted d-block mt-1">
                            {{ region.total_cinemas }} rạp
                        </span>
                    </h4>
                    <span class="text-danger" v-if="isSelectedRegion(region)">
                        <i class="fe fe-check-circle"></i>
                    </span>
                </a>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, inject } from 'vue'
import axios from 'axios'

const root = inject('root')
const search = ref('')
const regions = ref([])
const errors = ref([])

const filteredRegions = computed(() => {
    if (search.value === '') return regions.value
    return regions.value.filter(region => {
        return region.name.toLowerCase().includes(search.value.toLowerCase()) ||
               (region.alias && region.alias.toLowerCase().includes(search.value.toLowerCase()))
    })
})

const isSelectedRegion = (region) => {
    return root.getRegion() === region.id
}

const doChangeRegion = (region) => {
    const modal = document.getElementById('locationModalTrigger').Modal
    if (root.getRegion() !== region.id) {
        root.setRegion(region.id)
        root.loading()
        window.location = url('orn_web_cinema_region', { slug: region.slug })
        modal.hide()
    } else {
        modal.hide()
    }
}

const url = (routeName, params) => {
    return root.url(routeName, params)
}

const getRegions = async () => {
    try {
        const baseUri = process.env.MOVEEK_API_ENDPOINT
        const response = await axios.get(`${baseUri}/v1/regions?order[priority]=ASC`)
        regions.value = response.data
    } catch (error) {
        errors.value.push(error)
    }
}

onMounted(() => {
    getRegions()
})
</script>

<style scoped>
</style>